import { MantineTheme } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import dayjs from "dayjs";
import { ComponentProps } from "react";

export const getCurrentDateDayStyleFunction: (
  theme: MantineTheme
) => ComponentProps<typeof DatePicker>["dayStyle"] =
  (theme) =>
  (date, { selected }) => {
    const today = new Date();
    const dateIsToday = dayjs(date).isSame(today, "day");
    if (dateIsToday) {
      return {
        backgroundColor: theme.colors.green[6],
        color: "white",
      };
    } else if (selected) {
      return {
        backgroundColor: theme.colors.green[1],
        color: "#000",
      };
    }
    return {};
  };
